import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-array-index-key */
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ContentImageBlock from './ContentImageBlock';
import css from './FeaturesFlipScroller.module.scss';
import scrollTop from '../../utils/dom/scrollTop';
import windowHeight from '../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LISTENER_THRESHOLD = 0.1; // fraction of component visible required for scroll listening

var STEPS = 10; // steps to determine number of observation points

var buildThreshold = function buildThreshold(steps) {
  return Array(steps + 1).fill(0).map(function (_, index) {
    return Math.round(index / steps * 100) / 100 || 0;
  });
};

var FeaturesFlipScroller = /*#__PURE__*/function (_PureComponent) {
  _inherits(FeaturesFlipScroller, _PureComponent);

  var _super = _createSuper(FeaturesFlipScroller);

  function FeaturesFlipScroller(props) {
    var _this;

    _classCallCheck(this, FeaturesFlipScroller);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleScrollListener", function (on) {
      _this.isListening = on;
      var method = "".concat(on ? 'add' : 'remove', "EventListener");
      window[method]('scroll', _this.onMessagesScroll, {
        passive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onIntersect", function (entries) {
      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio;
        var inView = intersectionRatio > LISTENER_THRESHOLD;
        var shouldUpdate = inView && !_this.isListening || !inView && _this.isListening;

        if (shouldUpdate) {
          _this.toggleScrollListener(inView);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      if (!_this.messageRefs.length) {
        return;
      }

      _this.windowHeight = windowHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "onMessagesScroll", function () {
      var index = _this.state.index;

      var _assertThisInitialize = _assertThisInitialized(_this),
          messageRefs = _assertThisInitialize.messageRefs;

      var nextIndex = messageRefs.findIndex(function (message) {
        if (!message || !message.current) {
          return false;
        }

        var content = message.current.querySelector(".".concat(css.messageInner));
        var bounds = content.getBoundingClientRect();
        var height = bounds.height,
            top = bounds.top;
        return top * 2 >= height;
      });

      if (nextIndex > -1 && nextIndex !== index) {
        _this.setState({
          index: nextIndex
        });
      } // Set to last index of page loads below FlipScroller.


      var _assertThisInitialize2 = _assertThisInitialized(_this),
          rootRef = _assertThisInitialize2.rootRef;

      if (!rootRef || !rootRef.current) {
        return false;
      }

      var rootEl = rootRef.current;

      var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
          height = _rootEl$getBoundingCl.height,
          bottom = _rootEl$getBoundingCl.bottom;

      var bottomRoot = height + bottom;
      var lastIndex = messageRefs.length - 1;

      if (scrollTop() >= bottomRoot && index !== lastIndex) {
        _this.setState({
          index: lastIndex
        });
      }

      return false;
    });

    _this.state = {
      index: 0
    };
    var features = _this.props.features;
    _this.bgInnerRef = /*#__PURE__*/React.createRef();
    _this.messageRefs = features.map(function () {
      return /*#__PURE__*/React.createRef();
    });
    _this.rootRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(FeaturesFlipScroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var threshold = buildThreshold(STEPS);
      this.onResize();
      this.observer = new IntersectionObserver(this.onIntersect, {
        threshold: threshold
      });
      this.observer.observe(this.rootRef.current);
      this.toggleScrollListener(true);
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
      this.toggleScrollListener(false);
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var features = this.props.features;
      var index = this.state.index;
      return /*#__PURE__*/_jsx("section", {
        className: css.root,
        ref: this.rootRef,
        children: /*#__PURE__*/_jsxs("ul", {
          className: css.features,
          children: [/*#__PURE__*/_jsx("li", {
            className: css.bg,
            children: features.map(function (ft, fIndex) {
              var bgClass = cc([css.bgImageWrap, _defineProperty({}, css.active, fIndex === index)]);
              return /*#__PURE__*/_jsx("div", {
                className: css.bgInner,
                children: /*#__PURE__*/_jsx("div", {
                  className: bgClass,
                  children: /*#__PURE__*/_jsx(ContentImageBlock, _objectSpread(_objectSpread({}, ft), {}, {
                    description: ft.quote,
                    imageRight: true
                  }))
                })
              }, "bg-".concat(ft.id, "-").concat(fIndex));
            })
          }), features.map(function (ft, fIndex) {
            return /*#__PURE__*/_jsx("li", {
              className: css.feature,
              ref: _this2.messageRefs[fIndex],
              children: /*#__PURE__*/_jsx("div", {
                className: css.messageInner
              })
            }, "feature-".concat(ft.id, "-").concat(fIndex));
          })]
        })
      });
    }
  }]);

  return FeaturesFlipScroller;
}(PureComponent);

FeaturesFlipScroller.propTypes = {
  features: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    quote: PropTypes.string,
    quoter: PropTypes.string,
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    }).isRequired,
    title: PropTypes.string
  })).isRequired
};
export default FeaturesFlipScroller;